import {Component, EventEmitter, Input, Output} from '@angular/core';
import {CoreComponent} from "../../../../core/component/core-component/core.component";
import {ScheduleDto, ScheduleTypeDto, ScheduleTypeInternal} from "../../../../core/interfaces/core.types";
import {DeviceDetectorService} from "ngx-device-detector";
import {ActivatedRoute, Router} from "@angular/router";
import {OnboardingService} from "../../../../ob/api/onboarding.service";
import {BookingAppointmentDto, BookingSlotDto, BookingTimePeriodDto} from "../../../bookings/types/bookings.types";
import {findFlatIndexEntryPoint} from "@angular/compiler-cli/src/ngtsc/entry_point";

@Component({
  selector: 'schedule-appointment-type',
  templateUrl: 'schedule-appointment-type.component.html',
})
export class ScheduleAppointmentTypeComponent extends CoreComponent {

  @Input() scheduleTypes: ScheduleTypeDto[] | undefined;
  @Input() appointmentTypeId: number | undefined;

  @Input() selectedType?: ScheduleTypeDto;
  @Output() selectedTypeChange: EventEmitter<ScheduleTypeDto> = new EventEmitter<ScheduleTypeDto>();

  @Output() onSelectBookingPeriod: EventEmitter<BookingSlotDto | null> = new EventEmitter<BookingSlotDto | null>();


  isTouchDevice: boolean = false;
  selectedScheduleType: string | undefined;
  showPreviousButton: boolean = false;
  //selectedTypeInternal: ScheduleTypeInternal | undefined;

  //@Output() onSelectScheduledType: EventEmitter<ScheduleTypeDto> = new EventEmitter<ScheduleTypeDto>();
  //@Output() onAppointmentScheduled: EventEmitter<BookingAppointmentDto> = new EventEmitter<BookingAppointmentDto>();

  constructor(
    private deviceService: DeviceDetectorService,
    protected router: Router,
    protected activatedRoute: ActivatedRoute) {
    super();
  }

  override ngOnInit() {
    super.ngOnInit();
    this.initComponent();
  }

  handleSelectPeriodBooking(event: BookingSlotDto | null) {
    this.onSelectBookingPeriod.emit(event);
  }

  initComponent() {

    this.activatedRoute.queryParams.subscribe(params => {
      let selectedType: ScheduleTypeDto | undefined;

      if (params['typeId'] != undefined) {
        if (this.scheduleTypes != undefined) {
          selectedType = this.scheduleTypes.find(entry => entry.id == params['typeId']);
        }
      }

      // store selected type
      this.selectedType = selectedType;

      // open WhatsApp in case of
      if (this.selectedType && this.selectedType.scheduleTypeInternal == ScheduleTypeInternal.whatsapp) {
        if (this.isTouchDevice) {
          const phoneNumber: string = this.selectedType.uiMessageContact;
          const whatsAppUrl: string = `https://wa.me/${phoneNumber}`;
          window.open(whatsAppUrl, '_blank')
        }
      }

      if (!this.activatedRoute.routeConfig?.path?.startsWith('service/')) {
        this.showPreviousButton = false;
      } else {
        this.showPreviousButton = true;
      }
    });


    if (this.deviceService.isMobile() || this.deviceService.isTablet()) {
      this.isTouchDevice = true;
    } else {
      this.isTouchDevice = false;
    }

    this.scheduleTypes = this.scheduleTypes?.sort((a, b) => a.uiPriority - b.uiPriority);
    this.refreshComponent()
  }

  refreshComponent() {
    this.initialized = true;
  }

  handleScheduleTypeSelect(type: ScheduleTypeDto) {
    const contact = type?.uiMessageContact?.replace(/\s+/g, "");
    let queryParams: { typeId: number, contact?: string } = {
      typeId: type.id
    };

    if (contact) {
      queryParams.contact = contact;
    }

    this.selectedTypeChange.emit(type);

    if (ScheduleTypeInternal.whatsapp != type.scheduleTypeInternal && ScheduleTypeInternal.bookings != type.scheduleTypeInternal && ScheduleTypeInternal.call_us != type.scheduleTypeInternal && ScheduleTypeInternal.vcard_qr != type.scheduleTypeInternal) {
      this.router.navigate([], {
        relativeTo: this.activatedRoute,
        queryParams: queryParams,
        queryParamsHandling: 'merge',
      });
      this.selectedTypeChange.emit(type);
    } else {
      if (this.isTouchDevice && ScheduleTypeInternal.call_us == type.scheduleTypeInternal) {
        window.location.href = `tel:${contact}`;
      } else
        this.router.navigate([], {
          relativeTo: this.activatedRoute,
          queryParams: queryParams,
          queryParamsHandling: 'merge',
        });
    }
  }

  handlePreviousStep() {
    this.router.navigate(['/ci/service/5/schedule']);
  }

  handleAppointmentScheduled(appointment: BookingAppointmentDto) {
    // this.onAppointmentScheduled.emit(appointment);
  }

  protected readonly ScheduleTypeInternal = ScheduleTypeInternal;
}
